// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1I9KA","col":"CardReaderDesc_col__2FD41","label":"CardReaderDesc_label__2moum"};